import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

import { header, label, paragraph, TYPOGRAPHY, uppercaseLabel } from '../../theme/typographyV2'

type HeaderType = Extract<TYPOGRAPHY, `header${number}`>
type ParagraphType = Extract<TYPOGRAPHY, `paragraph${number}`>
type LabelType = Extract<TYPOGRAPHY, `label${number}`>
type UppercaseLabelType = Extract<TYPOGRAPHY, `uppercaseLabel${string}`>

interface TextV2Props extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  className?: string
  type?: TYPOGRAPHY
}

export const TextV2 = ({ children, className, type = TYPOGRAPHY.paragraph1, ...rest }: TextV2Props) => {
  const getTypographyClasses = () => {
    if (type?.startsWith('header')) {
      return header({ type: type as HeaderType })
    } else if (type?.startsWith('paragraph')) {
      return paragraph({ type: type as ParagraphType })
    } else if (type?.startsWith('label')) {
      return label({ type: type as LabelType })
    } else if (type?.startsWith('uppercaseLabel')) {
      return uppercaseLabel({ type: type as UppercaseLabelType })
    }
    return paragraph({ type: type as ParagraphType })
  }

  const typographyClasses = getTypographyClasses()
  const classes = twMerge([typographyClasses, className])

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}
